import React, { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabaseClient';

const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";
const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b', morado:'#534AB7' };

export default function ModalPensamiento({ pensamientoId, currentUserId, membership, onCerrar }) {
  const [pensamiento, setPensamiento] = useState(null);
  const [autor, setAutor] = useState(null);
  const [reacciones, setReacciones] = useState({ aplauso:0, corazon:0, gratitud:0 });
  const [misReacciones, setMisReacciones] = useState({});
  const [loading, setLoading] = useState(true);

  const isFree = !membership || membership === 'free_observer' || membership === 'tu_radar';

  useEffect(() => {
    const cargar = async () => {
      const { data: p } = await supabase.from('pensamientos').select('*').eq('id', pensamientoId).single();
      if (!p || (p.visibilidad === 'privado' && p.user_id !== user?.id)) { setLoading(false); return; }
      setPensamiento(p);

      const { data: prof } = await supabase.from('profiles').select('full_name, business_name, business_type, avatar_url').eq('id', p.user_id).single();
      setAutor(prof);

      const { data: reacs } = await supabase.from('pensamiento_reacciones').select('tipo, user_id').eq('pensamiento_id', pensamientoId);
      const counts = { aplauso:0, corazon:0, gratitud:0 };
      const mine = {};
      (reacs || []).forEach(r => { counts[r.tipo]++; if (r.user_id === currentUserId) mine[r.tipo] = true; });
      setReacciones(counts);
      setMisReacciones(mine);
      setLoading(false);
    };
    cargar();
  }, [pensamientoId, currentUserId]);

  const toggleReaccion = async (tipo) => {
    if (!currentUserId) return;
    if (misReacciones[tipo]) {
      await supabase.from('pensamiento_reacciones').delete().match({ pensamiento_id: pensamientoId, user_id: currentUserId, tipo });
      setReacciones(prev => ({ ...prev, [tipo]: prev[tipo] - 1 }));
      setMisReacciones(prev => { const n = { ...prev }; delete n[tipo]; return n; });
    } else {
      await supabase.from('pensamiento_reacciones').insert({ pensamiento_id: pensamientoId, user_id: currentUserId, tipo });
      setReacciones(prev => ({ ...prev, [tipo]: prev[tipo] + 1 }));
      setMisReacciones(prev => ({ ...prev, [tipo]: true }));
    }
  };

  if (loading || !pensamiento) return null;

  const esMio = pensamiento.user_id === currentUserId;
  const nombre = autor?.full_name || autor?.business_name || 'Emprendedor';

  return (
    <>
      <div onClick={onCerrar} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', backdropFilter:'blur(8px)', WebkitBackdropFilter:'blur(8px)', zIndex:999 }} />
      <div onClick={e => e.stopPropagation()} style={{ position:'fixed', top:'50%', left:'50%', transform:'translate(-50%,-50%)', width:560, maxWidth:'calc(100vw - 40px)', maxHeight:'80vh', overflowY:'auto', background:'rgba(20,20,30,0.97)', border:'1px solid rgba(255,255,255,0.12)', borderRadius:20, padding:'24px 28px', zIndex:1000, fontFamily:font, color:'#fff' }}>
        {/* Header */}
        <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16 }}>
          <div style={{ width:40, height:40, borderRadius:'50%', background:'linear-gradient(135deg, #5dc1b9, #FDBE02)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:14, fontWeight:600 }}>
            {nombre[0]}
          </div>
          <div style={{ flex:1 }}>
            <p style={{ margin:0, fontSize:14, fontWeight:500 }}>{nombre}</p>
            <p style={{ margin:0, fontSize:11, color:'rgba(255,255,255,0.5)' }}>{autor?.business_type || ''} · {new Date(pensamiento.created_at).toLocaleDateString('es')}</p>
          </div>
          <button onClick={onCerrar} style={{ width:30, height:30, background:'rgba(255,255,255,0.08)', border:'none', borderRadius:'50%', color:'rgba(255,255,255,0.7)', fontSize:16, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>×</button>
        </div>

        {/* Tags */}
        {pensamiento.tags?.length > 0 && (
          <div style={{ display:'flex', gap:6, marginBottom:12, flexWrap:'wrap' }}>
            {pensamiento.tags.map((t, i) => <span key={i} style={{ padding:'3px 9px', background:'rgba(93,193,185,0.12)', color:C.turquesa, borderRadius:999, fontSize:11 }}>{t}</span>)}
          </div>
        )}

        {/* Title + Content */}
        <h1 style={{ fontFamily:serif, fontSize:22, fontWeight:400, margin:'0 0 12px' }}>{pensamiento.titulo}</h1>
        <div style={{ fontSize:14, color:'rgba(255,255,255,0.85)', lineHeight:1.75, marginBottom:20 }} dangerouslySetInnerHTML={{ __html: pensamiento.contenido }} />

        {/* Reactions */}
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', borderTop:'0.5px solid rgba(255,255,255,0.08)', paddingTop:16 }}>
          <div style={{ display:'flex', gap:8 }}>
            {[
              { tipo:'aplauso', emoji:'👏' },
              { tipo:'corazon', emoji:'❤️' },
              { tipo:'gratitud', emoji:'🙏' },
            ].map(r => (
              <button key={r.tipo} onClick={() => toggleReaccion(r.tipo)} style={{
                padding:'6px 12px', background: misReacciones[r.tipo] ? 'rgba(93,193,185,0.15)' : 'rgba(255,255,255,0.04)',
                border: misReacciones[r.tipo] ? '0.5px solid rgba(93,193,185,0.3)' : '0.5px solid rgba(255,255,255,0.08)',
                borderRadius:50, fontSize:13, cursor:'pointer', color:'#fff', display:'flex', alignItems:'center', gap:4, fontFamily:'inherit',
              }}>
                {r.emoji} <span style={{ fontSize:11 }}>{reacciones[r.tipo]}</span>
              </button>
            ))}
          </div>

          {esMio ? (
            <span style={{ fontSize:12, color:'rgba(255,255,255,0.4)' }}>Tu pensamiento</span>
          ) : isFree ? (
            <span style={{ fontSize:11, color:C.mango }}>🔒 Conecta · Spark $139/mes</span>
          ) : (
            <button style={{ padding:'8px 16px', background:C.turquesa, border:'none', borderRadius:8, color:'#fff', fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:'inherit' }}>
              💬 Mandar mensaje
            </button>
          )}
        </div>
      </div>
    </>
  );
}
